$(document).on("input change", "*[data-enable]", function () {
  var arr = $(this).attr("data-enable");
  var target = arr.split(" ");
  if ($(this).val() != "") {
    for (var i = 0; i < target.length; i++) {
      $("#" + target[i]).removeAttr("disabled");
    }
  } else {
    for (var i = 0; i < target.length; i++) {
      $("#" + target[i]).attr("disabled", true);
    }
  }
});
